import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { AuthService } from 'src/app/seguranca/auth.service';
import { environment } from 'src/environments/environment';
import { NotificacaoVencimentoService } from '../service/notificacao-vencimento.service';

@Component({
  selector: 'app-layout-notificacao-vencimento',
  templateUrl: './layout-notificacao-vencimento.component.html',
  styleUrl: './layout-notificacao-vencimento.component.scss',
  standalone: true,
  imports: [CommonModule, RouterModule, ButtonModule],
})
export class LayoutNotificacaoVencimentoComponent implements OnInit {
  private notificacaoVencimentoService = inject(NotificacaoVencimentoService);
  private readonly authService = inject(AuthService);

  controlaAssinatura = environment.controlaAssinatura;

  _mensagem?: string | null;

  mensagemBloqueio?: string;

  tipoPacote = 'R';

  constructor() {
    const authService = this.authService;

    this.tipoPacote = authService.jwtPayload?.tipoPacote ?? 'R';
  }

  ngOnInit(): void {
    this.notificacaoVencimentoService.mensagemVencimento.subscribe({
      next: (msg) => {
        this._mensagem = msg;
      },
    });

    if (!this._mensagem && this.authService.jwtPayload?.mensagemVencimento) {
      this.notificacaoVencimentoService.setMensagem(
        this.authService.jwtPayload?.mensagemVencimento,
      );
    }

    this.mensagemBloqueio = this.authService.jwtPayload?.mensagemBloqueio;
  }

  get mensagem() {
    return this._mensagem;
  }
}
